"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[38305],{

/***/ 93512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconBulletPIN; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function IconBulletPIN() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_1978_22924)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        cx: "10",
                        cy: "9.99967",
                        r: "9.16667",
                        fill: "#CCEEE1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        cx: "10",
                        cy: "10",
                        r: "5",
                        fill: "#00AB6B"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_1978_22924",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 26941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LoginInputPin; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/assets/customIcon/IconBulletPIN.tsx
var IconBulletPIN = __webpack_require__(93512);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/LoginInputPin/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48px !important;\n  height: 56px;\n  font-size: 24px;\n  border-radius: 8px;\n  text-align: center;\n  margin-right: 10px;\n  border: 0;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  &:focus {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 300px;\n  height: 48px;\n\n  #pin-mask {\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    width: 300px;\n    height: 48px;\n    gap: 4px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 9999;\n  background: transparent;\n  width: 300px;\n  text-align: center;\n  font-size: 20px;\n  border: none;\n  outline: none;\n  color: transparent;\n  letter-spacing: 12px;\n  caret-color: #00AB6B;\n  font-weight: bold;\n\n  ::selection {\n    color: transparent;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 24px;\n  gap: 6px;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var LoginInputNumber = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-23743495-0"
})(_templateObject(), color/* default.primary */.Z.primary);
var InputPINWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-23743495-1"
})(_templateObject1());
var InputPINNumber = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({
    type: "text"
}).withConfig({
    componentId: "sc-23743495-2"
})(_templateObject2());
var ErrorMessageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-23743495-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/LoginInputPin/LoginInputPin.tsx
/* eslint-disable react/no-array-index-key */ 








var KEY_CODE_BACKSPACE = 8;
var KEY_CODE_ENTER = 13;
function LoginInputPin(param) {
    var onChangePIN = param.onChangePIN, onPressEnter = param.onPressEnter, errorMsg = param.errorMsg, _isError = param.isError, isError = _isError === void 0 ? false : _isError;
    var inputRef = (0,react.useRef)();
    var ref = (0,react.useState)(""), pinValue = ref[0], setPinValue = ref[1];
    var onChangeInput = function(e) {
        var value = e.target.value;
        if (value.length > 12) return;
        setPinValue(value);
    };
    var onKeyDown = function(e) {
        var numKeyValue = Number(e.key);
        if (e.keyCode === KEY_CODE_ENTER && pinValue.length >= 6) {
            onPressEnter(pinValue);
        }
        if (Number.isNaN(numKeyValue) && e.keyCode !== KEY_CODE_BACKSPACE && e.key.length === 1) {
            e.preventDefault();
        }
    };
    (0,react.useEffect)(function() {
        if (onChangePIN) {
            onChangePIN(pinValue);
        }
    }, [
        pinValue
    ]);
    (0,react.useEffect)(function() {
        if (isError) {
            // reset input on error
            setPinValue("");
        }
    }, [
        isError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "center",
                width: "100%",
                style: {
                    cursor: "text"
                },
                onClick: function() {
                    return inputRef.current.focus();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputPINWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputPINNumber, {
                            value: pinValue,
                            onChange: onChangeInput,
                            onKeyDown: onKeyDown,
                            pattern: "\\d*",
                            ref: inputRef,
                            onBlur: function(param) {
                                var target = param.target;
                                return target.focus();
                            },
                            autoFocus: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "pin-mask",
                            children: Array.from(pinValue).map(function(value, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBulletPIN/* default */.Z, {}, index);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: errorMsg && errorMsg !== "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        align: "center",
                        color: color/* default.sunsetOrange */.Z.sunsetOrange,
                        "data-cy": "input-pin-error",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "icon/alert/info-warning.svg",
                                style: {
                                    marginRight: 4
                                }
                            }),
                            errorMsg
                        ]
                    })
                })
            })
        ]
    });
};
LoginInputPin.defaultProps = {
    errorMsg: ""
};


/***/ }),

/***/ 38305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FL": function() { return /* reexport */ AuthModalLoading; },
  "lr": function() { return /* reexport */ Carousel; },
  "WR": function() { return /* reexport */ LoginInputPin/* default */.Z; },
  "qW": function() { return /* reexport */ VirtualTradingButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/VirtualTradingButton/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 16px;\n  border-radius: 12px;\n  border: 1px solid ",
        ";\n  justify-content: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var VirtualTradingButtonContainer = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs(function(props) {
    return {
        // @ts-expect-error
        justify: props.justify || "center"
    };
}).withConfig({
    componentId: "sc-23022bb0-0"
})(_templateObject(), color/* default.downgray */.Z.downgray, function(param) {
    var justify = param.justify;
    return justify;
});

// EXTERNAL MODULE: ./src/features/securities/AuthModal/types.ts
var types = __webpack_require__(41110);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
// EXTERNAL MODULE: ./src/global/VirtualTrading/stores/useFormulaStore.ts
var useFormulaStore = __webpack_require__(62544);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/store.ts
var AuthModal_store = __webpack_require__(70175);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/constants.ts
var constants = __webpack_require__(54855);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/hooks/useVirtualLogin.ts













var useTradingStore = (0,esm/* default */.ZP)(trading/* default */.Z);
function useVirtualLogin(setLoading) {
    var resetErrorCode = useTradingStore().resetErrorCode;
    var showTradingModal = (0,store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var ref = (0,AuthModal_store/* default */.Z)(), closeModal = ref.closeModal, tradingModalConfig = ref.tradingModalConfig;
    var loadFormula = (0,useFormulaStore/* default */.Z)(function(s) {
        return s.loadFormula;
    });
    var loadLoginVirtual = (0,useSecuritiesCredentialStore/* default */.Z)(function(s) {
        return s.loadLoginVirtual;
    });
    var switchToVirtual = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return loadLoginVirtual();
                    case 4:
                        _ctx.next = 6;
                        return loadFormula();
                    case 6:
                        resetErrorCode();
                        (0,AlertErrorMessage/* default */.Z)("Kamu berhasil masuk ke Akun Virtual Trading", "plain-green");
                        if (tradingModalConfig !== null && !tradingModalConfig.onVirtualLoginSuccess) {
                            showTradingModal((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tradingModalConfig), {
                                orderType: constants/* AUTH_MODAL_CONFIG.virtual */.n.virtual[tradingModalConfig.orderType]
                            }));
                        }
                        if (tradingModalConfig === null || tradingModalConfig === void 0 ? void 0 : tradingModalConfig.onVirtualLoginSuccess) {
                            tradingModalConfig.onVirtualLoginSuccess();
                        }
                        closeModal();
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,logger/* default */.ZP)(Error("Failed to Switch to Virtual"), {
                            event: "useVirtualLogin@switchToVirtual"
                        });
                    case 16:
                        setLoading(false);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function switchToVirtual() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        switchToVirtual: switchToVirtual
    };
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/VirtualTradingButton/VirtualTradingButton.tsx








function VirtualTradingButton(param) {
    var title = param.title, type = param.type, setLoading = param.setLoading;
    var switchToVirtual = useVirtualLogin(setLoading).switchToVirtual;
    var _obj;
    var imgWidth = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types/* AuthModalType.LOGIN */.O.LOGIN, "40px"), (0,_define_property/* default */.Z)(_obj, types/* AuthModalType.REGISTER */.O.REGISTER, "40px"), (0,_define_property/* default */.Z)(_obj, types/* AuthModalType.PROGRESS */.O.PROGRESS, "32px"), _obj);
    var getTitle = function() {
        if (type === types/* AuthModalType.REGISTER */.O.REGISTER) {
            return(// @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                family: "bold",
                ml: "8px",
                children: [
                    "Virtual ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " Trading"
                ]
            }));
        }
        return(// @ts-expect-error
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            family: "bold",
            ml: "8px",
            children: title
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingButtonContainer, {
        "data-cy": "virtual-trading-button-auth",
        width: type === types/* AuthModalType.REGISTER */.O.REGISTER ? "50%" : "",
        justify: type === types/* AuthModalType.REGISTER */.O.REGISTER ? "left" : "center",
        onClick: switchToVirtual,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justify: "center",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: "virtual-trading",
                    src: "/img/virtual.svg",
                    width: imgWidth[type]
                }),
                getTitle()
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/Carousel/constants.ts
var CAROUSEL_DATA = [
    {
        url: "/img/illustration_1.svg",
        title: "Biaya Broker yang Rendah",
        description: "Fee beli 0,15%. Fee jual 0,25%"
    },
    {
        url: "/img/illustration_2.svg",
        title: "Gratis Stockbit Pro",
        description: "Setiap nasabah dapat akses Stockbit Pro tanpa biaya."
    },
    {
        url: "/img/illustration_4.svg",
        title: "Tanpa Minimal Deposit",
        description: "Mulai investasi tanpa modal besar."
    },
    {
        url: "/img/illustration_5.svg",
        title: "Buka Rekening 1 Hari Kerja",
        description: "Tanpa perlu kirim dokumen fisik."
    }, 
];

// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 9 modules
var carousel = __webpack_require__(61980);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/Carousel/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: -24px;\n\n  .slick-prev,\n  .slick-next {\n    z-index: 1;\n    display: none !important;\n  }\n\n  &:hover .slick-prev,\n  &:hover .slick-next {\n    display: block !important;\n  }\n\n  .slick-next {\n    right: 16px;\n  }\n\n  .slick-prev {\n    left: 16px;\n  }\n\n  .slick-dots {\n    width: auto;\n\n    li {\n      width: 2px;\n      bottom: -24px;\n    }\n\n    li button {\n      background: gray;\n      width: 5px;\n      height: 5px;\n      border-radius: 10px;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    li.slick-active {\n      width: 13px;\n      margin-right: 0;\n    }\n\n    li.slick-active button {\n      width: 13px;\n      height: 5px;\n      background: ",
        ";\n      border: unset;\n    }\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 300px !important;\n  margin: auto;\n  display: flex !important;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto 24px;\n  width: 200px;\n  height: 200px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var AuthModalCarousel = (0,styled_components_browser_esm/* default */.ZP)(carousel/* default */.Z).withConfig({
    componentId: "sc-720ed5e7-0"
})(styled_templateObject(), color/* default.primary */.Z.primary);
var CarouselItemContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-720ed5e7-1"
})(_templateObject1());
var CarouselImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-720ed5e7-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/Carousel/Carousel.tsx





function Carousel() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            maxWidth: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModalCarousel, {
            autoplay: true,
            arrows: true,
            nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/next-arrow.svg",
                alt: "next arrow"
            }),
            prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/prev-arrow.svg",
                alt: "previous arrow"
            }),
            children: CAROUSEL_DATA.map(function(param) {
                var url = param.url, title = param.title, description = param.description;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CarouselItemContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselImage, {
                            alt: title,
                            src: url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            align: "center",
                            size: "20px",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            align: "center",
                            mt: "12px",
                            size: "16px",
                            children: description
                        })
                    ]
                });
            })
        })
    });
};

// EXTERNAL MODULE: ./src/features/securities/AuthModal/components/LoginInputPin/LoginInputPin.tsx + 1 modules
var LoginInputPin = __webpack_require__(26941);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50888);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/AuthModalLoading/AuthModalLoading.tsx






var loadingIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {
    style: {
        fontSize: 24,
        color: color/* default.highgray */.Z.highgray
    },
    spin: true
});
function AuthModalLoading() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        "data-cy": "auth-modal-loading",
        direction: "column",
        justify: "center",
        align: "center",
        width: "100%",
        height: "374px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                indicator: loadingIcon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "#858585",
                mt: "16px",
                children: "Authenticating..."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/index.tsx







/***/ }),

/***/ 62544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export useFormulaStore */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38597);
/* harmony import */ var _api_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86408);







var initialState = {
    formula: {}
};
var useFormulaStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .persist */ .tJ)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadFormula: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, axiosData, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,_api_config__WEBPACK_IMPORTED_MODULE_1__/* .getFormula */ .p)();
                    case 3:
                        ref = _ctx.sent;
                        axiosData = ref.data;
                        data = axiosData.data;
                        set({
                            formula: data
                        });
                        return _ctx.abrupt("return", data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }))
    });
}, {
    name: "virtualFormula"
}));
/* harmony default export */ __webpack_exports__["Z"] = (useFormulaStore);


/***/ })

}]);